'use client';
import { yaNative } from '@weberus/ui/utils/ya-native';
import config from '@/conf';
import { useImpressionLog } from '@/app/_shared/hooks/use-impression-log';

interface SearchSpellCorrectionProps {
  keyword?: string;
  onImpression?: () => void;
  onClick?: () => void;
}

export const SearchSpellCorrection = ({ keyword = '', onImpression, onClick }: SearchSpellCorrectionProps) => {
  const url = `${config.service.home.origin}/results?keyword=${encodeURIComponent(keyword)}&category=local`;

  const ref = useImpressionLog(() => {
    if (onImpression) {
      onImpression();
    }
  });

  const handleItemClick = () => {
    if (onClick) {
      onClick();
    }

    if (yaNative.isEnabled) {
      yaNative.wv({ url, previousWebDismiss: 1 });
    } else {
      window.location.replace(url);
    }
  };

  return (
    <div ref={ref} className="mt-16 h-40 w-full">
      <div className="flex h-full items-center justify-center rounded-8 bg-fill-primary-weak">
        <span className="typography-body-14-regular">이것을 찾으셨나요?</span>
        <a
          href={url}
          className="ml-4 text-text-hyperlink-main underline underline-offset-2 typography-body-14-bold"
          onClick={handleItemClick}>
          {keyword}
        </a>
      </div>
    </div>
  );
};
